import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"fabric_mask_title"} defaultMessage={"Cuidado com o uso da máscara de tecido"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
            <p><b><FormattedMessage id={"fabric_mask_text_1"} defaultMessage={"Como eu devo lavar a máscara?"}/></b></p>
                <ol>
                    <li><FormattedMessage id={"fabric_mask_text_2"} defaultMessage={"Água sanitária: após o uso, mergulhe em água sanitária por 20 minutos."}/></li>
                    <li><FormattedMessage id={"fabric_mask_text_3"} defaultMessage={"Água e sabão: Depois, lave com água e sabão."}/></li>
                    <li><FormattedMessage id={"fabric_mask_text_4"} defaultMessage={"Lave separadamente: Lave a máscara separada de outras roupas."}/></li>
                    <li><FormattedMessage id={"fabric_mask_text_5"} defaultMessage={"Passado a máscara: depois de secar, é recomendado passar com ferro quente."}/></li>
                    <li><FormattedMessage id={"fabric_mask_text_6"} defaultMessage={"Guarde a máscara: guarde a máscara em um local limpo e seco."}/></li>
                </ol>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;